@if (applicationStatus) {
<div [class]="getStatusColour(applicationStatus)">
    <svg class="h-1.5 w-1.5" [class]="getStatusDot(applicationStatus)" viewBox="0 0 6 6" aria-hidden="true">
        <circle cx="3" cy="3" r="3" />
    </svg>
    <span class="text-sm font-medium">{{ getInviteStatus(applicationStatus) }}</span>
</div>
}